import {definePreset} from "@primevue/themes";
import Aura from "@primevue/themes/aura";

const StayPrimevuePreset = definePreset(Aura, {
    semantic: {
        primary: {
            100: '{red.100}',
            200: '{red.200}',
            300: '{red.300}',
            400: '#F35345',
            500: '{red.500}',
            600: '{red.600}',
            700: '{red.700}',
            800: '{red.800}',
            900: '{red.900}',
        }
    },
})

export default StayPrimevuePreset